// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__tnJYd","modalContent":"Modal_modalContent__oGqDY"};